// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPayrollGroupDto } from './IPayrollGroupDto';
import {
    IPayrollGroupDtoFromJSON,
    IPayrollGroupDtoFromJSONTyped,
    IPayrollGroupDtoToJSON,
    IPayrollGroupDtoToJSONTyped,
} from './IPayrollGroupDto';
import type { IPlanLiteDto } from './IPlanLiteDto';
import {
    IPlanLiteDtoFromJSON,
    IPlanLiteDtoFromJSONTyped,
    IPlanLiteDtoToJSON,
    IPlanLiteDtoToJSONTyped,
} from './IPlanLiteDto';

/**
 * 
 * @export
 * @interface IPayrollCalendarAggregatorResponseDto
 */
export interface IPayrollCalendarAggregatorResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IPayrollCalendarAggregatorResponseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarAggregatorResponseDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarAggregatorResponseDto
     */
    frequency_type?: IPayrollCalendarAggregatorResponseDtoFrequencyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarAggregatorResponseDto
     */
    group_type?: IPayrollCalendarAggregatorResponseDtoGroupTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IPayrollCalendarAggregatorResponseDto
     */
    start_date?: Date;
    /**
     * 
     * @type {Array<IPlanLiteDto>}
     * @memberof IPayrollCalendarAggregatorResponseDto
     */
    plans?: Array<IPlanLiteDto>;
    /**
     * 
     * @type {Array<IPayrollGroupDto>}
     * @memberof IPayrollCalendarAggregatorResponseDto
     */
    payroll_groups?: Array<IPayrollGroupDto>;
}

/**
* @export
* @enum {string}
*/
export enum IPayrollCalendarAggregatorResponseDtoFrequencyTypeEnum {
    WEEKLY = 'WEEKLY',
    BI_WEEKLY = 'BI_WEEKLY',
    MONTHLY = 'MONTHLY',
    SEMI_MONTHLY = 'SEMI_MONTHLY',
    ANNUALLY = 'ANNUALLY'
}
/**
* @export
* @enum {string}
*/
export enum IPayrollCalendarAggregatorResponseDtoGroupTypeEnum {
    ALL = 'ALL',
    GROUP = 'GROUP',
    PLAN = 'PLAN'
}


/**
 * Check if a given object implements the IPayrollCalendarAggregatorResponseDto interface.
 */
export function instanceOfIPayrollCalendarAggregatorResponseDto(value: object): value is IPayrollCalendarAggregatorResponseDto {
    return true;
}

export function IPayrollCalendarAggregatorResponseDtoFromJSON(json: any): IPayrollCalendarAggregatorResponseDto {
    return IPayrollCalendarAggregatorResponseDtoFromJSONTyped(json, false);
}

export function IPayrollCalendarAggregatorResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPayrollCalendarAggregatorResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'frequency_type': json['frequency_type'] == null ? undefined : json['frequency_type'],
        'group_type': json['group_type'] == null ? undefined : json['group_type'],
        'start_date': json['start_date'] == null ? undefined : (new Date(json['start_date'])),
        'plans': json['plans'] == null ? undefined : ((json['plans'] as Array<any>).map(IPlanLiteDtoFromJSON)),
        'payroll_groups': json['payroll_groups'] == null ? undefined : ((json['payroll_groups'] as Array<any>).map(IPayrollGroupDtoFromJSON)),
    };
}

export function IPayrollCalendarAggregatorResponseDtoToJSON(json: any): IPayrollCalendarAggregatorResponseDto {
    return IPayrollCalendarAggregatorResponseDtoToJSONTyped(json, false);
}

export function IPayrollCalendarAggregatorResponseDtoToJSONTyped(value?: IPayrollCalendarAggregatorResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'frequency_type': value['frequency_type'],
        'group_type': value['group_type'],
        'start_date': value['start_date'] == null ? undefined : ((value['start_date']).toISOString()),
        'plans': value['plans'] == null ? undefined : ((value['plans'] as Array<any>).map(IPlanLiteDtoToJSON)),
        'payroll_groups': value['payroll_groups'] == null ? undefined : ((value['payroll_groups'] as Array<any>).map(IPayrollGroupDtoToJSON)),
    };
}

